import { render } from "./BuilderButton.vue?vue&type=template&id=0156e42e&scoped=true"
import script from "./BuilderButton.vue?vue&type=script&lang=js"
export * from "./BuilderButton.vue?vue&type=script&lang=js"

import "./BuilderButton.vue?vue&type=style&index=0&id=0156e42e&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0156e42e"]])

export default __exports__